/* Quick View modal — fetches a self-contained product snippet via the
   Shopify section-rendering API (?section_id=quick-view-content) instead of
   scraping the live product page, since this theme's product template does
   not use Dawn's <product-info> wrapper that quick-add.js depends on. */
if (!customElements.get('mapett-quick-view-modal')) {
  customElements.define(
    'mapett-quick-view-modal',
    class MapettQuickViewModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="MapettQuickViewInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        const spinner = opener.querySelector('.loading__spinner');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        const baseUrl = opener.getAttribute('data-product-url');
        const separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
        const url = baseUrl + separator + 'section_id=quick-view-content';

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const content = html.querySelector('.quick-view');
            if (content && this.modalContent) {
              this.modalContent.innerHTML = '';
              this.modalContent.appendChild(content);
            }
            super.show(opener);
          })
          .catch((error) => {
            console.error('Quick view failed to load:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
